<template>
  <div class="login">
    <nav class="navbar">
      <div class="logo">Building Inspection System 登陆</div>
    </nav>
    <div class="alpha-mask">
      <div class="login-form">
        <blockquote><h4>用户登录</h4></blockquote>
        <el-form action="/systemUser/login" :model="loginForm" ref="loginForm">
          <el-form-item prop="loginName" :rules="{required: true, message: '账号不能为空', trigger:'blur'}">
            <el-input v-model="loginForm.loginName" auto-complete="off" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="password" :rules="{required: true, message: '密码不能为空', trigger:'blur'}">
            <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
          </el-form-item>
<!--          <el-form-item prop="verify" :rules="{min:4,max:4,required: true, message: '请输入右图中的图形验证码', trigger:'blur'}">
            <el-input v-model="loginForm.verify" auto-complete="off" placeholder="图形验证码"></el-input>
            <div class="captcha">
              <img :src="captcha" @click="refreshCaptcha">
            </div>
          </el-form-item>-->
          <el-form-item>
            <el-button class="submit" type="primary" @click.native="onSubmit">登入</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import * as constants from '../../utils/constants'
  export default {
    name: 'login',
    data () {
      return {
        captcha: '',
        loginForm: {
          loginName: '',
          password: '',
          verify: ''
        }
      }
    },
    created () {
      this.refreshCaptcha()
    },
    methods: {
      refreshCaptcha () {
        this.captcha =process.env.HOST_NAME + '/systemUser/verify?t=' + new Date().getTime();
      },
      onSubmit () {
        this.$refs['loginForm'].validate(valid => {
          if (valid) {
            this.$http.post(this.$refs['loginForm'].$attrs.action, {
              loginName: this.loginForm.loginName,
              password: this.loginForm.password,
    /*          verify: this.loginForm.verify*/
            }).then(response => {
              if (response.data.code == "1") {
                sessionStorage.setItem(constants.USERINFO,JSON.stringify(response.data.data.userInfo));
                sessionStorage.setItem(constants.TOKEN,response.data.data.token);
                this.$router.push("/");
              }
            }).catch(e => {
              Vue.set(this.loginForm, 'verify', '')
              this.refreshCaptcha()
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style>
  .login {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    /*background: url('../assets/nipic.jpg') 50% 50% / cover no-repeat fixed;*/
  }
  .login nav.navbar {
    height: 50px;
    background-color: #233050;
    color: white;
  }
  .login .logo {
    font-size: 20px;
    font-weight: 600;
    line-height: 50px;
    margin: 0 20px;
  }
  .login blockquote {
    padding-left: 10px;
    font-size: 17px;
    margin: 0;
    border-left: 5px solid #eeeeee;
  }
  .login blockquote h4 {
    padding-left: 10px;
    font-size: 18px;
    margin: 0;
  }
  .login .login-form {
    display: inline-block;
    text-align: left;
    margin-top: 100px;
    width: 350px;
    padding: 35px 35px 15px;
    box-shadow: 0 0 8px 0 rgba(0,0,0,.06), 0 1px 0 0 rgba(0,0,0,.02);
    border-radius: 10px;
    -moz-border-radius: 5px;
    background-color: #fff;
  }
  .login .el-form {
    padding: 40px 0 10px;
  }
  .login .el-form-item {
    padding: 0 5px;
    margin-bottom: 22px;
  }
  .login .el-input .el-input__inner {
    height: 35px;
    border: none;
    border-bottom: solid 1px #eee;
    border-radius: 0;
  }
  .login .alpha-mask {
    position: fixed;
    top:0;
    left:0;
    bottom:0;
    right:0;
    background-color: rgba(0,0,0,.4);
    text-align: center;
  }
  .login .submit {
    width: 100%;
    background-color: #407aaa;
    border: solid 1px #407aaa;
    border-radius: 20px;
    margin-top: 10px;
  }
  .login .captcha {
    position: absolute;
    right: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Login.vue